import React from "react";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Page from "../../Page";
import { Textbox, Radiobox } from "react-inputs-validation";
import Select from 'react-select';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FetchGuardarBeneficiariosCoberturasEndosos, FetchListadoBeneficiarios, FetchListadoBeneficiariosCoberturas, FetchListadoEntidadesFinancieras } from "../../../redux/actions/aEndososBeneficiarios";
import { coloresEstadosEndososBeneficiarios } from "../../../utils/constants";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";
import { Growl } from "primereact/growl";
import { urlDescargarPdf } from "../../../constants/urls";

class SeleccionEndososHogar extends React.Component {

    constructor(props) {
        super(props);
        const estructuraSuma =
            props.endosoSeleccionado.sumasAseguradas["Estructura"] &&
                props.coberturasSeleccionadas["Estructura"] ?
                props.endosoSeleccionado.sumasAseguradas["Estructura"] : undefined;
        const contenidoSuma =
            props.endosoSeleccionado.sumasAseguradas["Contenidos"] &&
                props.coberturasSeleccionadas["Contenidos"] ?
                props.endosoSeleccionado.sumasAseguradas["Contenidos"] : undefined;
        const formulario = {};
        const totalSumasAseguradas = {};
        if (estructuraSuma !== undefined) {
            formulario["Estructura"] = estructuraSuma;
            totalSumasAseguradas["Estructura"] = 0;
        }
        if (contenidoSuma !== undefined) {
            formulario["Contenidos"] = contenidoSuma;
            totalSumasAseguradas["Contenidos"] = 0;
        }
        this.state = {
            poliza: "",
            sucursal: "",
            ramo: "",
            tipoBeneSelect: "entidadFin",
            entidadesFinancierasSelect: [],
            entidadesFinancieras: null,
            razonSocial: "",
            entidad: "",
            razonSocialOtro: "",
            sumaAsegurada: props.endosoSeleccionado.data.sumaAsegurada,
            beneficiariosEndosos: [],
            form: formulario,
            totalSumaAsegurada: 0,
            sumasAseguradas: props.endosoSeleccionado.sumasAseguradas,
            totalSumasAseguradas: totalSumasAseguradas,
            errores: {},
            loading: false
        }
    }

    async componentDidMount() {

        await this.listarBeneficiariosEndososPantalla();
        const entidadesFinancieras = await this.props.listarEntidadesFinancieras({
            "empCodigo": "AIGMETROPOLITANA"
        });

        this.setState({
            entidadesFinancierasSelect: entidadesFinancieras,
        });
    }

    listarBeneficiariosEndososPantalla = async () => {
        window.scrollTo(0, 0);
        const queryParams = new URLSearchParams(this.props.location.search);
        const poliza = queryParams.get("poliza");
        const sucursal = queryParams.get("sucursal");
        const ramo = queryParams.get("ramo");

        const body = {
            poliza,
            sucursal,
            ramo
        };
        this.setState(body);
        const bodyBeneficiarios = {
            "empCodigo": "AIGMETROPOLITANA",
            ...body,
            items: this.props.endosoSeleccionado.data,
        };
        await this.props.listarBeneficiariosEndosos(bodyBeneficiarios);
    }

    componentDidUpdate(prevProps, prevState) {

        const { sumaAsegurada } = this.props.endosoSeleccionado.data;
        const { sumasAseguradas } = this.state;
        const { datosBeneficiariosTabla } = this.props;

        if (datosBeneficiariosTabla.datosBeneficiarios.data !== prevProps.datosBeneficiariosTabla.datosBeneficiarios.data
            && datosBeneficiariosTabla.datosBeneficiarios.data !== undefined &&
            Array.isArray(datosBeneficiariosTabla.datosBeneficiarios.data)
        ) {
            const formulario = {};
            const totalSumasAseguradas = {};
            const total = datosBeneficiariosTabla.datosBeneficiarios.total;
            const totalEstructuras = datosBeneficiariosTabla.datosBeneficiarios.totalEstructuras;
            const totalContenidos = datosBeneficiariosTabla.datosBeneficiarios.totalContenidos;
            const sumaFaltante = sumaAsegurada - total;
            const sumaFaltanteEstructuras = (sumasAseguradas["Estructura"] ? sumasAseguradas["Estructura"] - totalEstructuras : 0);
            const sumaFaltanteContenidos = (sumasAseguradas["Contenidos"] ? sumasAseguradas["Contenidos"] - totalContenidos : 0);
            if (this.props.coberturasSeleccionadas["Estructura"]) {
                formulario["Estructura"] = sumaFaltanteEstructuras.toFixed(2);
                totalSumasAseguradas["Estructura"] = totalEstructuras;
            }
            if (this.props.coberturasSeleccionadas["Contenidos"]) {
                formulario["Contenidos"] = sumaFaltanteContenidos.toFixed(2);
                totalSumasAseguradas["Estructura"] = totalContenidos;
            }
            this.setState({
                beneficiariosEndosos: datosBeneficiariosTabla.datosBeneficiarios.data,
                totalSumaAsegurada: total,
                totalSumasAseguradas,
                totalSumaAseguradaLabel: datosBeneficiariosTabla.datosBeneficiarios.totalLabel,
                sumaAsegurada: sumaFaltante.toFixed(2),
                form: formulario
            });
        }

        if (datosBeneficiariosTabla.isLoadingBeneficiarios !== prevProps.datosBeneficiariosTabla.isLoadingBeneficiarios) {
            this.setState({
                loading: datosBeneficiariosTabla.isLoadingBeneficiarios
            })
        }
    }



    showWarn = (message) => {
        this.growl.show({
            severity: "error",
            summary: "Información",
            detail: message,
        });
    };

    validar = () => {
        const newErrors = {};
        const {
            entidadesFinancieras,
            entidad,
            tipoBeneSelect,
            form,
            sumasAseguradas,
            totalSumasAseguradas
        } = this.state;

        const {
            coberturasSeleccionadas
        } = this.props;

        if (tipoBeneSelect === "entidadFin" && !entidadesFinancieras) {
            newErrors.entidadesFinancieras = "Entidad financiera requerida";
        }

        if (tipoBeneSelect !== "entidadFin" && !entidad) {
            newErrors.entidad = "Entidad financiera requerida";
        }


        Object.entries(coberturasSeleccionadas).forEach(([key, value]) => {
            if (!form[key]) {
                newErrors[key] = "Suma asegurada requerida"
                return;
            }

            if (form[key]) {
                if (Number.parseFloat(form[key]) + Number.parseFloat(totalSumasAseguradas[key]) > sumasAseguradas[key]
                ) {
                    newErrors[key] = `No se puede superar el valor asegurado de ${key}`;
                    this.showWarn(`Revise los valores ingresados`);
                    return;
                }

                if (Number.parseFloat(form[key]) <= 0) {
                    newErrors[key] = `El valor de la suma asegurada de ${key} debe ser un número mayor a 0`;
                    this.showWarn(`Revise los valores ingresados`);
                    return;
                }
            }
        });
        this.setState({ errores: newErrors });

        return Object.keys(newErrors).length === 0;
    };

    guardarBeneficiarios = async () => {
        const {
            poliza,
            sucursal,
            ramo,
            tipoBeneSelect,
            entidadesFinancieras,
            entidad,
            sumaAsegurada,
            totalSumaAsegurada,
            form
        } = this.state;

        const {
            datosUsuarios
        } = this.props;

        const coberturasParseadas = this.parseCoberturas();

        if (!this.validar()) return;
        const razonBeneficiario = tipoBeneSelect === "entidadFin" ? entidadesFinancieras["value"] : entidad;
        const body = {
            empCodigo: "AIGMETROPOLITANA",
            datosAsesor: {
                codigoCore: datosUsuarios.cliCodigoCore,
                nombre: this.props.datosUsuarios.brokerNombre
                    ? this.props.datosUsuarios.brokerNombre
                    : ""
            },
            ambiente: "Desarrollo",
            poliza,
            sucursal,
            ramo,
            items: this.props.endosoSeleccionado.data,
            form: {
                tipoBeneficiario: tipoBeneSelect,
                beneficiario: razonBeneficiario,
                valorAsegurado: Number.parseFloat(sumaAsegurada),
                coberturas: coberturasParseadas
            }
        };

        await this.props.guardarBeneficiariosEndosos(body);
        await this.listarBeneficiariosEndososPantalla();
    }
    parseCoberturas = () => {
        const { form } = this.state;
        const coberturasParseadas = {};
        Object.entries(form).forEach(([key, value]) => {
            coberturasParseadas[key] = Number.parseFloat(value)
        });
        return coberturasParseadas;
    }

    descargarPdf = async (urlPdf) => {
        this.setState({
            loading: true
        });
        const response = await fetch(`${urlDescargarPdf}&url=${urlPdf}`);
        if (!response.ok) {
            const data = await response.json();
            this.showWarn('Error al descargar.');
            this.setState({
                loading: false
            });
            return;
        }

        // Obtener nombre del archivo
        let nombreArchivo = urlPdf.match(/\/([^/?#]+\.pdf)(?:\?|#|$)/i)[1] ? urlPdf.match(/\/([^/?#]+\.pdf)(?:\?|#|$)/i)[1] : 'documento.pdf';

        const blob = await response.blob();
        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.download = nombreArchivo;
        link.click();
        URL.revokeObjectURL(link.href);
        this.setState({
            loading: false
        });
    }

    renderDataEndosos = () => {
        const {
            tipoBeneSelect,
            entidadesFinancieras,
            entidadesFinancierasSelect,
            entidad,
            beneficiariosEndosos,
            totalSumaAseguradaLabel,
            errores,
            form
        } = this.state;
        const {
            coberturasSeleccionadas
        } = this.props;

        const coberturas = Object.entries(coberturasSeleccionadas).map(([key, value]) => ({ key, value }));
        return (
            <Row style={{ marginLeft: 0, marginRight: 0 }}>
                <Growl ref={(el) => (this.growl = el)} life="5000" />
                <Col>
                    {coberturas.length > 0 && (
                        <>
                            <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                                Datos endoso:
                            </div>

                            <Row>
                                <Col>
                                    <Row style={{ marginLeft: 0, marginRight: 0 }}>
                                        <Col >
                                            Beneficiario:
                                        </Col>
                                    </Row>
                                    <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
                                        <Col lg={6} md={6} sm={12} xs={12} style={{
                                            paddingLeft: "80px",
                                            display: "flex",
                                            gap: "20px",
                                            flexDirection: "column"
                                        }}>
                                            <div className="left-side" style={{ marginLeft: "-35px" }}>
                                                <Radiobox
                                                    optionList={[{
                                                        "id": "entidadFin",
                                                        "name": "Entidad Financiera"
                                                    }]}
                                                    id="entidadFin"
                                                    name="entidadFin"
                                                    value={tipoBeneSelect}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            tipoBeneSelect: e,
                                                            entidad: ""
                                                        }, () => {
                                                            this.validar()
                                                        });
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <Select
                                                    tabIndex="1"
                                                    id={"seleccionBeneficiario"}
                                                    name={"seleccionBeneficiario"}
                                                    value={entidadesFinancieras}
                                                    options={entidadesFinancierasSelect}
                                                    placeholder={
                                                        "Seleccione la entidad financiera"
                                                    }
                                                    onChange={(selec, e) => {
                                                        this.setState({ entidadesFinancieras: selec }, (() => {
                                                            this.validar()
                                                        }));
                                                    }}
                                                    onBlur={() => { this.validar() }}
                                                    isDisabled={tipoBeneSelect !== "entidadFin"}
                                                />
                                                <span style={{ fontSize: "12px", color: "red" }}>
                                                    {tipoBeneSelect === "entidadFin" ? errores.entidadesFinancieras : ""}
                                                </span>
                                            </div>

                                        </Col>
                                        <Col lg={6} md={6} sm={12} xs={12} style={{
                                            paddingLeft: "80px",
                                            display: "flex",
                                            gap: "20px",
                                            flexDirection: "column"
                                        }}>
                                            <div className="left-side" style={{ marginLeft: "-35px" }}>
                                                <Radiobox
                                                    optionList={[{
                                                        "id": "otros",
                                                        "name": "Otros"
                                                    }]}
                                                    id="otros"
                                                    name="otros"
                                                    value={tipoBeneSelect}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            tipoBeneSelect: e,
                                                            entidadesFinancieras: null
                                                        }, () => {
                                                            this.validar()
                                                        });
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <Textbox
                                                    customStyleInput={{
                                                        height: "38px",
                                                        marginBottom: "0px"
                                                    }}
                                                    tabIndex="1"
                                                    type="input"
                                                    value={entidad}
                                                    name="entidad"
                                                    id="entidad"
                                                    classNameInput={"form-control"}
                                                    placeholder={'Ingresa la nueva entidad'}
                                                    onChange={(entidad, e) =>
                                                        this.setState({ entidad: entidad, hasEntidadError: false })
                                                    }
                                                    onBlur={() => { this.validar() }}
                                                    disabled={tipoBeneSelect === "entidadFin"}
                                                    style={{ height: "34px" }}
                                                    validate={false}
                                                    validationOption={{
                                                        name: "entidad",
                                                        check: false,
                                                        required: true,
                                                        msgOnError:
                                                            ""
                                                    }}
                                                />
                                                <span style={{ fontSize: "12px", color: "red" }}>
                                                    {tipoBeneSelect !== "entidadFin" ? errores.entidad : ""}
                                                </span>
                                            </div>
                                            <div>
                                            </div>

                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </>
                    )}
                    <Row>
                        <Col>
                            <Row style={{ marginLeft: 0, marginRight: 0 }}>
                                {coberturas.map((cobertura) => (
                                    <Col lg={6} md={6} sm={12} xs={12}>
                                        {`Suma Asegurada ${cobertura.key} :`}
                                    </Col>
                                ))}
                            </Row>
                            <Row style={{ marginLeft: 0, marginRight: 0 }}>
                                {coberturas.map((nomCobertura, cobertura) => {
                                    return (
                                        <Col lg={6} md={6} sm={12} xs={12} style={{ paddingLeft: "80px" }}>
                                            <Textbox
                                                tabIndex="1"
                                                type="input"
                                                value={form[nomCobertura.key]}
                                                name={`sumaAsegurada-${nomCobertura.key}`}
                                                id={`sumaAsegurada-${nomCobertura.key}`}
                                                classNameInput={"form-control"}
                                                placeholder={'Ingrese la suma asegurada'}
                                                onChange={(value) => {
                                                    const regex = /^\d*([.]\d{0,2})?$/;
                                                    if (regex.test(value)) {
                                                        form[nomCobertura.key] = value;
                                                        this.setState({
                                                            form
                                                        });
                                                    }
                                                }}
                                                onBlur={() => { this.validar() }}
                                                validate={false}
                                                validationOption={{
                                                    name: "sumaAsegurada",
                                                    check: false,
                                                    required: true,
                                                    msgOnError:
                                                        "Por favor ingrese la suma asegurada del beneficiario"
                                                }}

                                            />
                                            <span style={{ fontSize: "12px", color: "red" }}>
                                                {errores[nomCobertura.key]}
                                            </span>
                                        </Col>
                                    )

                                })}

                            </Row>
                            {coberturas.length > 0 && <Row>
                                <Col style={{ display: "flex", justifyContent: "end" }}>
                                    <Button
                                        className="btn btn-white"
                                        onClick={() => {
                                            this.setState({ validate: true });
                                            this.props.onRegresar();
                                        }}
                                        style={{
                                            display: "block",
                                            width: "210px"
                                        }}
                                    >
                                        {` Cancelar`} {/* ${NumUbicacion} */}
                                    </Button>
                                </Col>
                                <Col style={{ display: "flex", justifyContent: "start" }}>
                                    <Button
                                        className="btn btn-primary"
                                        onClick={async () => {
                                            this.setState({ validate: true });
                                            await this.guardarBeneficiarios();
                                        }}
                                        style={{
                                            display: "block",
                                            width: "210px"
                                        }}
                                    >
                                        {` Guardar`} {/* ${NumUbicacion} */}
                                    </Button>
                                </Col>
                            </Row>}
                            {beneficiariosEndosos.length > 0 && (<Row>
                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                    <div style={{
                                        background: "#fff",
                                        border: "1px solid #ced4da",
                                        padding: "15px",
                                        width: "85%",
                                        marginTop: "15px"
                                    }}>
                                        <Row style={{ marginLeft: 0, marginRight: 0 }}>
                                            <DataTable
                                                value={beneficiariosEndosos}
                                                paginator={false}
                                                responsive
                                                className="custom-table-nb"
                                                rowHover
                                                emptyMessage="No se han encontrado resultados"
                                            >
                                                <Column
                                                    className="counter custom-tabe-nb-td"
                                                    field="contador"
                                                    header="#"
                                                    style={{ width: "60px", height: "85px" }}
                                                />
                                                <Column
                                                    field="benEndBeneficiario"
                                                    header="Beneficiario"
                                                    style={{ width: "100px", height: "85px" }}
                                                />
                                                <Column
                                                    header="Fecha endoso"
                                                    field="benEndFechaEndoso"
                                                    style={{ width: "150px", height: "85px" }}
                                                />
                                                <Column
                                                    header="Suma Asegurada Estructura"
                                                    field=""
                                                    style={{ width: "150px", height: "85px" }}
                                                    body={(rowData) => {
                                                        return (
                                                            <div>
                                                                {
                                                                    rowData.coberturaEstructurasLabel
                                                                }
                                                            </div>
                                                        );
                                                    }}
                                                />
                                                <Column
                                                    header="Suma Asegurada Contenidos"
                                                    field=""
                                                    style={{ width: "150px", height: "85px" }}
                                                    body={(rowData) => {
                                                        return (
                                                            <div>
                                                                {
                                                                    rowData.coberturaContenidosLabel
                                                                }
                                                            </div>
                                                        );
                                                    }}
                                                />
                                                <Column
                                                    header="Suma Asegurada Total"
                                                    field="benEndSumaAseguradaLabel"
                                                    style={{ width: "100px", height: "85px" }}
                                                />
                                                <Column
                                                    header="Estado"
                                                    field="benEndEstado"
                                                    style={{ width: "150px", height: "85px" }}
                                                    body={(rowData) => {
                                                        return (
                                                            <div className={`custom-state-badge`} style={{ backgroundColor: `${coloresEstadosEndososBeneficiarios[rowData.benEndEstado]}` }}>
                                                                {rowData.benEndEstado}
                                                            </div>
                                                        );
                                                    }}
                                                />
                                                <Column
                                                    header="Acciones"
                                                    field="benEndEstado"
                                                    style={{ width: "150px", height: "85px" }}
                                                    body={(rowData) => {
                                                        if (
                                                            rowData.benEndEstado === "APROBADO"
                                                        ) {
                                                            return (
                                                                <button
                                                                    className='btn btn-detail-white'
                                                                    onClick={() => this.descargarPdf(rowData.benEndUrlPdf)}
                                                                    rel='noopener noreferrer'>
                                                                    <i
                                                                        className='fa fa-cloud-download'
                                                                        aria-hidden='true'
                                                                    />{" "}
                                                                    DESCARGAR ENDOSO
                                                                </button>
                                                            );
                                                        }
                                                    }}
                                                />
                                            </DataTable>
                                        </Row>
                                        <Row >
                                            <Col xl={6} lg={6} md={6}>
                                            </Col>
                                            <Col xl={6} lg={6} md={6} style={
                                                {
                                                    display: "flex",
                                                    justifyContent: "start",
                                                    color: "#001871",
                                                    gap: "20px"
                                                }
                                            }>
                                                <div>Suma total</div>
                                                <div style={
                                                    {
                                                        display: "flex",
                                                        border: "1px solid #ced4da",
                                                        width: "250px",
                                                        justifyContent: "center"
                                                    }
                                                }>
                                                    {totalSumaAseguradaLabel}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>)}

                        </Col>

                    </Row>
                </Col>
            </Row>
        )
    }

    render() {
        const {
            datosBeneficiariosTabla
        } = this.props;
        return (
            <LoadingScreen
                loading={this.state.loading}
                bgColor="#f1f1f1"
                spinnerColor="#001871"
                textColor="#676767"
                logoSrc={logo}
                text={"Obteniendo registros..."}
            >
                <Page
                    title={
                        "Ingreso de endoso beneficiario"
                    }
                >
                    <Col xl={12} style={{ marginBottom: "0px" }}>
                        <Row style={{ marginLeft: 0, marginRight: 0 }}>
                            <Col>
                                <Button className={"button-white"} onClick={() => { this.props.onRegresar() }}>
                                    <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                                    REGRESAR
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    {
                        this.props.cabecera
                    }
                    {
                        this.renderDataEndosos()
                    }
                </Page>
            </LoadingScreen >
        )
    }
}

const mapStateToProps = (state) => ({
    datosBeneficiariosTabla: state.dataBeneficiariosEndosos,
    datosUsuarios: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = (dispatch) => {
    return {
        listarEntidadesFinancieras: (params) => dispatch(FetchListadoEntidadesFinancieras(params)),
        listarBeneficiariosEndosos: (params) => dispatch(FetchListadoBeneficiariosCoberturas(params)),
        guardarBeneficiariosEndosos: (params) => dispatch(FetchGuardarBeneficiariosCoberturasEndosos(params))
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SeleccionEndososHogar)
);